export const GAMES_LIST_SUCCESS = "GAMES_LIST_SUCCESS";
export const GAMES_INFO_SUCCESS = "GAMES_INFO_SUCCESS";
export const GAMES_FILTER_HANDLING = "GAMES_FILTER_HANDLING";
export const GAMES_SEARCH_NAME = "GAMES_SEARCH_NAME";
export const GAMES_CATEGORY_SUCCESS = "GAMES_CATEGORY_SUCCESS";
export const CLEAR_GAMES_INFO = "CLEAR_GAMES_INFO";
export const GAMES_CATEGORY_INFO = "GAMES_CATEGORY_INFO";
export const IP_ADDRESS_INFO = "IP_ADDRESS_INFO";
export const VISITOR_VIEW_SUCCESS = "VISITOR_VIEW_SUCCESS";
export const VISITOR_GAME_SUCCESS = "VISITOR_GAME_SUCCESS";
